import { ThemedPage } from "../styled/templates/ThemedPage";

const Main = () => {
  return <ThemedPage></ThemedPage>;
};

export default Main;
